export default "__VITE_ASSET__e8f20672__"